<template>
  <div id="help">
    <div class="div-1">
     <h3>I 准备工作</h3>
      <ul class="div-2">
        <li>安装Chrome浏览器，并且安装浏览器数字钱包插件；</li>
        <ul class="div-2">
          <p class="div-2">
            步骤1. 【chrome】请打开
            <a href="https://github.com/ChengOrangeJu/WebExtensionWallet">
              https://github.com/ChengOrangeJu/WebExtensionWallet
            </a>
            &nbsp;然后按照流程安装钱包到浏览器；
          </p>
          <p class="div-2">
            步骤2. 设置您的帐户，请妥善包括你到钱包密码和私钥文件；
          </p>
          <p class="div-2">
            步骤3. 代币请到 <a href="https://gate.io">火币网 gate.io</a> 购买兑换；
          </p>
        </ul>
        <li>登录你的钱包，然后刷新当前页面，即可使用系统功能；</li>
      </ul>
    </div>

    <div class="div-1">
      <h3> I I  功能说明</h3>
      <li class="div-2">首页：查看最热和最新美食分享，查看美食详情，详情页面可以进行评价、打分、打赏； </li>
      <li class="div-2">美食分享：分享我体验过的美食； </li>
      <li class="div-2">我的分享：查看我分享过的美食； </li>
      <li class="div-2">关于：系统使用帮助；</li>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  #help {
    font-size: 14px;
    color: #606266;
  }
  #help .div-1 {
    text-align: left;
    margin: 20px;
  }
  #help .div-2 {
    text-align: left;
    margin-left: 20px;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base-help.vue